import styled from 'styled-components';

type TResponsive = {
  isMobile?: boolean;
  isDesktop?: boolean;
  isMediumSize?: boolean;
};

const SectionPlans = styled.div<TResponsive>`
  height: 950px;
  padding-left: 35px;
  padding-top: 40px;
  display: flex;
  flex-flow: column;
  align-items: center;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    height: 1000px;
    padding-top: 64px;
  `}
`;

const LabelSection = styled.h3<TResponsive>`
  font-weight: 900;
  font-size: 22px;
  margin-bottom: 16px;
  line-height: 30px;
  letter-spacing: -0.024em;
  color: #555a64;
  text-align: center;

  ${(props) =>
    props.isDesktop &&
    `
  font-size: 24px;
  line-height: 36px;
`}

  ${(props) =>
    props.isMediumSize &&
    `
  text-align: center;
`}
`;

const LabelSubtitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #6c757d;
`;

const PlansContainer = styled.div<TResponsive>`
  display: flex;
  gap: 24px;
  max-width: ${(props) => (props.isDesktop ? 'auto' : '100%')};

  .swiper {
    width: 100%;
    padding-top: 32px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
    margin-right: 24px;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }

  ${(props) =>
    props.isDesktop &&
    `
    float:left;

    .swiper-wrapper {
      place-content: center;
    }
  `}
`;

const PlanBox = styled.div`
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 8px;
  border-top: 8px solid #3cd278;
  border-color: ${(props) => props.color || '#3cd278'};
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding: 22px 34px 32px 34px;
  width: 312px;
`;

const PlanTitle = styled.p`
  font-family: Satoshi;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  letter-spacing: -0.008em;

  color: ${(props) => props.color || '#21af5a'};
`;

type PlanItemProps = {
  backgroundColor: string;
  iconColor: string;
};

const PlanItemStyle = styled.div<PlanItemProps>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  padding: 5px 0px;
  ${(props) => props.backgroundColor && `background: ${props.backgroundColor}; border-radius: 16px;`}
  ${(props) => props.backgroundColor && `padding: 8px 20px;`}

  & > svg {
    height: 16px;
    width: auto;
    flex-shrink: 0;
    color: ${(props) => props.iconColor || '#3cd278'};
  }
`;

const PlanItemText = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  margin: 0px;
  color: #6c757d;

  span {
    font-weight: 500;
  }

  strong {
    color: #000000;
    font-weight: bold;
  }
`;

const ReferencePlan = styled.span`
  margin-left: 3px;
  color: ${(props) => props.color || '#000000'};
`;

const Tag = styled.p`
  background: #f8f8f8;
  border-radius: 16px;
  color: ${(props) => props.color || '#0055fb'};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  padding: 2px 6px;
  margin-top: 30px;
  margin-bottom: 15px;
  width: fit-content;
`;

const AccordionLongWrapper = styled.div`
  margin-bottom: 50px;
`;

type FirstPartProps = {
  isExpanded: boolean;
};

const FirstPart = styled.div<FirstPartProps>`
  ${(props) =>
    props.isExpanded &&
    `
      span,
      strong {
        color: #6c757d;
        font-weight: 500 !important;
  }
`}
`;
const SecondPart = styled.div``;

const DiscountBlock = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding: 16px;
  background: radial-gradient(
      88.02% 352.08% at 7.4% 10.62%,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(235, 239, 203, 0.3) 24.59%,
      rgba(255, 244, 215, 0.3) 46.28%,
      rgba(230, 237, 255, 0.3) 68.86%,
      rgba(248, 218, 232, 0.3) 100%
    ),
    #ffffff;
  border-radius: 8px;
  & > svg {
    margin: 5px;
    margin-top: 0px;
    color: #0055fb;
  }
`;

const DiscountText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  & > p {
    color: #0055fb;
    margin: 0px;
  }
`;

const TabSection = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

type SwitchHeaderBtnProps = {
  position?: string;
  active?: boolean;
};

const SwitchHeaderBtn = styled.button<SwitchHeaderBtnProps>`
  border: none;
  min-width: 142px;
  border-radius: 10px;
  padding: 5px 10px;
  background: #ffffff;

  ${(props) =>
    props.active
      ? `
      color: #0055FB;
      background-color: #ffffff;
      box-shadow: 0px 10px 25px #6c757d26;
    `
      : `
      color: #6C757D;
      background-color: #F0F0F0;
    `};
  cursor: pointer;
  border-radius: ${(props) =>
    props.position === 'left' ? '24px 0px 0px 24px' : props.position === 'right' ? '0px 24px 24px 0px' : '0px'};
`;

export {
  SectionPlans,
  LabelSection,
  LabelSubtitle,
  PlansContainer,
  PlanBox,
  PlanTitle,
  PlanItemStyle,
  PlanItemText,
  ReferencePlan,
  Tag,
  AccordionLongWrapper,
  FirstPart,
  SecondPart,
  DiscountBlock,
  DiscountText,
  TabSection,
  SwitchHeaderBtn,
};
